import { CHAT_ENTRY_TYPES } from "components/OverlayButtons/ChatBox/chatConsts";
import { addChatEntryToDB } from "components/OverlayButtons/ChatBox/chatUtils";
import { useChatEntryBase } from "contexts/ChatHelperContext";
import { useGroupsAccessors } from "contexts/database/useGroupsAccessors";
import { useCurrentGroup } from "hooks/useCurrentGroup";
import React from "react";

export const usePingToChat = () => {
  const { update } = useGroupsAccessors();
  const { groupDoc } = useCurrentGroup();
  const groupId = groupDoc?.id;
  const chatContent = useChatEntryBase();

  const onPingEntry = (entry) => {
    addChatEntryToDB({
      update,
      groupId,
      entry: {
        ...chatContent,
        ...entry,
      },
    });
  };
  return {
    onPingEntry,
  };
};
